<div class="col-xs-12 sp-0 tt-comment" [ngClass]="{ 'tt-comment--current-user': ttIsCurrentUser }">
    <article>
        <h3 class="tt-input__label">
            <span ng-if="vm.ttAuthor !== null && vm.ttAuthor !== undefined">{{ ttAuthor }}</span>
            <span ng-if="vm.ttDatetime !== null && vm.ttDatetime !== undefined" class="tt-input__sublabel">- {{ ttDatetime | date : format + " hh:mm" }}</span>
        </h3>
        <div style="display: flex; justify-content: flex-end" [style.flexDirection]="ttIsCurrentUser ? 'row' : 'row-reverse'">
            <div class="tt-comment__actions">
                <ng-content select="tt-overflow-menu"></ng-content>
            </div>
            <div class="tt-comment__content" [innerHTML]="comment"></div>
        </div>
    </article>
</div>
